module.exports = __webpack_public_path__ + "media/images/iso-45001-b01f4ddcf446d4d19fd80230dff7bb18.jpg";